import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText = "Yes",
  cancelText = "No",
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <Box
        sx={{
          borderRadius: 2,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          boxShadow: 24,
          p: 4,
          minWidth: 320,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ color: "#1976d2", textAlign: "center" }}
          >
            {title}
          </Typography>
          {message && (
            <Typography
              variant="body1"
              sx={{ textAlign: "center", color: "text.secondary" }}
            >
              {message}
            </Typography>
          )}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              onClick={onConfirm}
              sx={{ textTransform: "capitalize", fontWeight: 600 }}
            >
              {confirmText}
            </Button>
            <Button
              variant="outlined"
              onClick={onCancel}
              sx={{
                textTransform: "capitalize",
                fontWeight: 600,
                borderColor: "#1976d2",
                color: "#1976d2",
              }}
            >
              {cancelText}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmDialog;
